import React, { useEffect, useState } from "react";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL } from "../../../API/API";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Lodingsubmit from "../../Loding/Loding";

export default function UpdateCombo() {
  const { id } = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState("0");
  const [vodafoneCash, setVodafoneCash] = useState("");
  const [instaPay, setInstaPay] = useState("");
  const [description, setDescription] = useState("");
  const [saveDraft, setSaveDraft] = useState(false);
  const [image, setImage] = useState(null);

  const [allChapters, setAllChapters] = useState([]);
  const [selectedChapters, setSelectedChapters] = useState([]);

  // Fetch all chapters
  useEffect(() => {
    async function fetchChapters() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/learning/chapters/all`);
        setAllChapters(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("فشل تحميل الشهور الدراسية");
      }
    }
    fetchChapters();
  }, [axiosPrivate]);

  // Fetch existing combo details
  useEffect(() => {
    async function fetchComboDetails() {
      setLoading(true);
      try {
        const res = await axiosPrivate.get(`${baseURL}/learning/combos/detail/${id}`);
        const combo = res.data?.data || {};
        setName(combo.name || "");
        setDescription(combo.description || "");
        setPrice(combo.price || "");
        setDiscount(combo.discount || "0");
        setVodafoneCash(combo.vodafone_cash || "");
        setInstaPay(combo.instapay || "");
        setSaveDraft(combo.is_draft || false);
        
        const preSelected = (combo.chapters || []).map(ch => ch.id);
        setSelectedChapters(preSelected);
      } catch (err) {
        console.error(err);
        toast.error("فشل تحميل تفاصيل الباقة");
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      fetchComboDetails();
    }
  }, [id, axiosPrivate]);

  const handleChapterToggle = (chapterId) => {
    if (selectedChapters.includes(chapterId)) {
      setSelectedChapters(prev => prev.filter(id => id !== chapterId));
    } else {
      setSelectedChapters(prev => [...prev, chapterId]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedChapters.length === 0) {
      toast.warning("يرجى اختيار شهر دراسي واحد على الأقل للكومبو");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", price);
    formData.append("discount", discount);
    formData.append("vodafone_cash", vodafoneCash);
    formData.append("instapay", instaPay);
    formData.append("description", description);
    formData.append("save", saveDraft ? "true" : "false");
    if (image) {
      formData.append("image", image);
    }
    if (selectedChapters.length > 0) {
      formData.append("chapter_ids", JSON.stringify(selectedChapters));
    }

    try {
      await axiosPrivate.post(`${baseURL}/learning/combos/update/${id}`, formData);
      toast.success("تم تحديث الباقة بنجاح");
      navigate("/DashboardLayout/combos");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "حدث خطأ أثناء تحديث الباقة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="p-4 content" dir="rtl">
        <h2 className="fw-bold mb-5">تعديل باقة كومبو</h2>

        <Form onSubmit={handleSubmit} className="Form w-75">
          <Form.Group className="floating-label-group mb-5">
            <Form.Control
              className="inpoutFeald"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder=" "
              required
            />
            <Form.Label>اسم باقة الكومبو</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label-group mb-5">
            <Form.Control
              className="inpoutFeald"
              as="textarea"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder=" "
              style={{ height: "auto", paddingTop: "25px" }}
            />
            <Form.Label>وصف الباقة (اختياري)</Form.Label>
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="floating-label-group mb-5">
                <Form.Control
                  className="inpoutFeald"
                  type="number"
                  min="0"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder=" "
                  required
                />
                <Form.Label>سعر الكومبو (جنيه)</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="floating-label-group mb-5">
                <Form.Control
                  className="inpoutFeald"
                  type="number"
                  min="0"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                  placeholder=" "
                />
                <Form.Label>الخصم (جنيه)</Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="floating-label-group mb-5">
                <Form.Control
                  className="inpoutFeald"
                  type="text"
                  value={vodafoneCash}
                  onChange={(e) => setVodafoneCash(e.target.value)}
                  placeholder=" "
                />
                <Form.Label>رقم فودافون كاش الخاص بالكومبو</Form.Label>
                <Form.Text className="text-muted text-end block">
                  اتركه فارغاً لاستخدام رقم الأدمن الأساسي الافتراضي.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="floating-label-group mb-5">
                <Form.Control
                  className="inpoutFeald"
                  type="text"
                  value={instaPay}
                  onChange={(e) => setInstaPay(e.target.value)}
                  placeholder=" "
                />
                <Form.Label>حساب انستا باي الخاص بالكومبو</Form.Label>
                <Form.Text className="text-muted text-end block">
                  اتركه فارغاً لاستخدام حساب انستا باي للأدمن.
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-5">
            <Form.Label className="fw-bold">صورة الباقة (كومبو)</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </Form.Group>

          <Card className="mb-5 p-4 border shadow-sm">
            <Card.Title className="fw-bold mb-4 text-primary">اختر الوحدات / الشهور الدراسية المشمولة</Card.Title>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {allChapters.length === 0 ? (
                <p className="text-muted">جاري تحميل الشهور الدراسية...</p>
              ) : (
                allChapters.map((ch) => (
                  <Form.Check
                    key={ch.id}
                    type="checkbox"
                    id={`ch-${ch.id}`}
                    label={`${ch.name} - ${ch.teacher?.name || "الأدمن"} (${ch.academic_year?.name || "عام"})`}
                    checked={selectedChapters.includes(ch.id)}
                    onChange={() => handleChapterToggle(ch.id)}
                    className="mb-3 fs-6"
                  />
                ))
              )}
            </div>
          </Card>

          <Form.Group className="mb-5">
            <Form.Check
              type="checkbox"
              label="حفظ كمسودة (لن يظهر للطلاب في الصفحة الرئيسية)"
              checked={saveDraft}
              onChange={(e) => setSaveDraft(e.target.checked)}
              className="fs-6"
            />
          </Form.Group>

          <Button type="submit" className="custom-brand-btn-dhash px-5 py-2">
            تحديث الباقة
          </Button>
        </Form>
      </div>
    </>
  );
}
